export default "__VITE_ASSET__DS30BQsn__"